<template>
    <div class="row mb-2">
        <div class="col-12 col-md-5 pe-0">
            <label for="">Tipe Filter</label>
            <div class="form-custom form-label form-border form-icon mb-0">
                <i class="bi bi-sliders font-13"></i>
                <select v-model="mutatedTypeFilter" @change="setDataFilter()" class="form-select rounded-xs" id="c6" aria-label="Floating label select example">
                    <option value="all" selected="">Semua</option>
                    <option value="monthly">Bulanan</option>
                    <option value="daily">Harian</option>
                    <option value="range">Range Tanggal</option>
                </select>
                <!-- <label for="c5" class="color-theme form-label-active">Pilih Jenis Filter</label> -->
                <div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
            </div>
        </div>
        <div class="col-12 col-md-7 pe-0" v-if="mutatedTypeFilter == 'daily'">
            <label for="">Tanggal</label>
            <div class="form-custom form-label form-border form-icon mb-0">
                <i class="bi bi-calendar font-12"></i>
                <input type="date" class="form-control rounded-xs" id="c5" @change="setDataDaily()" v-model="mutatedDailyTime">
                <!-- <label for="c5" class="color-theme form-label-active">Pilih Tanggal</label> -->
                <div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
            </div>
        </div>
        <div class="col-12 col-md-7 pe-0" v-if="mutatedTypeFilter == 'range'">
            <div class="row">
                <div class="col-md-6 pe-0">
                    <label for="">Tanggal Dari</label>
                    <div class="form-custom form-label form-border form-icon mb-0">
                        <i class="bi bi-calendar font-12"></i>
                        <input type="date" class="form-control rounded-xs" id="c5" @change="setDataRangeDateFrom()" v-model="mutatedRangeDateFrom">
                        <!-- <label for="c5" class="color-theme form-label-active">Pilih Tanggal</label> -->
                        <div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
                    </div>
                </div>
                <div class="col-md-6 pe-0">
                    <label for="">Tanggal Sampai</label>
                    <div class="form-custom form-label form-border form-icon mb-0">
                        <i class="bi bi-calendar font-12"></i>
                        <input type="date" class="form-control rounded-xs" id="c5" @change="setDataRangeDateTo()" v-model="mutatedRangeDateTo">
                        <!-- <label for="c5" class="color-theme form-label-active">Pilih Tanggal</label> -->
                        <div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-7 pe-0" v-if="mutatedTypeFilter == 'monthly'">
            <label for="">Bulan</label>
            <div class="form-custom form-label form-border form-icon mb-0">
                <i class="bi bi-calendar font-12"></i>
                <select v-model="mutatedMonthlyTime" @change="setDataMonthly()" class="form-select rounded-xs" id="c6" aria-label="Floating label select example">
                    <option value="" selected="">- Pilih Bulan -</option>
                    <option value="01">Januari</option>
                    <option value="02">Febuari</option>
                    <option value="03">Maret</option>
                    <option value="04">April</option>
                    <option value="05">Mei</option>
                    <option value="06">Juni</option>
                    <option value="07">Juli</option>
                    <option value="08">Agustus</option>
                    <option value="09">September</option>
                    <option value="10">Oktober</option>
                    <option value="11">November</option>
                    <option value="12">Desember</option>
                </select>
                <!-- <label for="c5" class="color-theme form-label-active">Pilih Jenis Filter</label> -->
                <div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
            </div>
        </div>
    </div>
</template>

<script>
// import { mapMutations, mapActions, mapState } from 'vuex'

import { emit } from 'process'

export default {
    props: ['typeFilter', 'dailyTime', 'monthlyTime', 'rangeDateFrom', 'rangeDateTo', ],
    name: 'ReportFilter',
    data() {
        return {
			mutatedTypeFilter: this.typeFilter,
            mutatedDailyTime: this.dailyTime,
            mutatedMonthlyTime: this.monthlyTime,
            mutatedRangeDateFrom: this.rangeDateFrom,
            mutatedRangeDateTo: this.rangeDateTo,
        }
    },
    async created() {
        
    },
    methods: {
        // ...mapMutations(['SET_LOADING', 'CLEAR_LOADING']),
        // ...mapActions('data', ['getPerformances']),
        // ...mapActions('teacherMe', ['getTeacherMe']),
		onChangeFilterReport(event) {
			if (event.target.value == 'monthly') this.selectedMontly = ''
		},
        setDataFilter() {
            const value = this.mutatedTypeFilter;
            this.$emit('update:typeFilter', value);
            if(value == "daily") {
                this.$emit('get-data-daily')
            }else if(value == "monthly") {
                this.$emit('get-data-monthly')
            }else if(value == "range") {
                this.$emit('get-data-range')
            }else{
                this.$emit('get-data-all')
            }
        },
        setDataDaily() {
            this.$emit('update:dailyTime', this.mutatedDailyTime);
            this.$emit('get-data-daily')
        },
        setDataMonthly() {
            this.$emit('update:monthlyTime', this.mutatedMonthlyTime);
            this.$emit('get-data-monthly')
        },
        setDataRangeDateFrom() {
            this.$emit('update:rangeDateFrom', this.mutatedRangeDateFrom);
            this.$emit('get-data-range');
        },
        setDataRangeDateTo() {
            this.$emit('update:rangeDateTo', this.mutatedRangeDateTo);
            this.$emit('get-data-range');
        }
    },
    computed: {
    }
}
</script>

<style scoped>
</style>
